import { render, staticRenderFns } from "./ProductFormat.vue?vue&type=template&id=4b0139a0&"
import script from "./ProductFormat.vue?vue&type=script&lang=js&"
export * from "./ProductFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports